<template>
  <section class="document-sample">
    <h2 class="document-sample__title" v-html="getTitleBlock(page, 'sample', 'title')"></h2>

    <div v-if="variant === variants.DIALOG" class="document-sample__dialog">
      <p
        v-for="(item, index) in items"
        :key="index"
        :class="['document-sample__bubble', { 'document-sample__bubble--answer': index % 2 === 1 }]"
      >
        <b>{{ item.key }}</b> <span v-html="item.value"></span>
      </p>
    </div>

    <div v-else-if="variant === variants.COMPARE" class="document-sample__compare">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="['document-sample__option', { 'document-sample__option--good': index === items.length - 1 }]"
      >
        <span class="document-sample__option-label">{{ item.key }}</span>
        <span v-html="item.value"></span>
      </div>
    </div>

    <div v-else class="document-sample__template">
      <p v-for="(item, index) in items" :key="index" class="document-sample__template-row">
        <b>{{ item.key }}</b> <span v-html="item.value"></span>
      </p>
    </div>

    <p class="document-sample__note">
      <span v-for="(note, index) in notes" :key="index" v-html="note + ' '"></span>
      <b class="document-sample__footnote" v-html="getTitleBlock(page, 'sample', 'description')"></b>
    </p>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { RESOURCE_SAMPLE_VARIANTS } from '@/features/agent-resources/config';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: RESOURCE_SAMPLE_VARIANTS.TEMPLATE,
    },
  },
  mixins: [ textBlock ],
  data() {
    return {
      variants: RESOURCE_SAMPLE_VARIANTS,
    };
  },
  computed: {
    items() {
      return this.getListBlock(this.page, 'sample-items');
    },
    notes() {
      return this.getListBlock(this.page, 'sample-notes');
    },
  },
};
</script>

<style lang="scss" scoped>
.document-sample {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px;
  border-radius: 28px;
  background: #EBF2FF;

  @media (max-width: 800px) {
    padding: 24px 16px;
  }

  &__title {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(30px, 3.4vw, 44px);
    line-height: 1.15;
  }

  &__dialog {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__bubble {
    align-self: flex-start;
    max-width: 640px;
    margin: 0;
    padding: 12px 16px;
    border-radius: 16px;
    background: #FFFFFF;
    font-size: 16px;
    line-height: 24px;

    &--answer {
      align-self: flex-end;
      background: #4555CC;
      color: #FFFFFF;
    }
  }

  &__compare {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
  }

  &__option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 18px 20px;
    border-radius: 16px;
    background: #FFFFFF;
    font-size: 16px;
    line-height: 24px;

    &--good {
      box-shadow: inset 0 0 0 2px #6171E4;

      .document-sample__option-label {
        background: #4555CC;
        color: #FFFFFF;
      }
    }
  }

  &__option-label {
    padding: 2px 10px;
    border-radius: 999px;
    background: #F0F1F3;
    font-size: 13px;
    font-weight: 600;
  }

  &__template {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 20px 22px;
    border-radius: 16px;
    background: #FFFFFF;
  }

  &__template-row {
    margin: 0;
    font-size: 16px;
    line-height: 25px;
  }

  &__note {
    margin: 0;
    font-size: 16px;
    line-height: 25px;
    color: #494E53;
  }

  &__footnote {
    color: #4555CC;
    font-weight: 600;
  }
}
</style>
